import { kebabCase } from 'lodash-es';

export const trimName = (string) =>
  string.split('{')[0].replace(/\b\w/g, (l) => l.toUpperCase());

export const trimIconName = (string) => kebabCase(string.split('"')[1]);
